import React from 'react';
import { CheckCircleFilled, ClockCircleOutlined } from '@ant-design/icons';
import type { PaymentStatus } from '../../types/provider';

interface Props {
  status: PaymentStatus | null | undefined;
  size?: 'sm' | 'md';
}

const PAID_BG = 'rgba(31,139,76,0.10)';
const PAID_COLOR = 'rgba(31,139,76,1)';
const UNPAID_BG = 'rgba(245,158,11,0.10)';
const UNPAID_COLOR = 'rgba(245,158,11,1)';

export const PaymentStatusBadge: React.FC<Props> = ({ status, size = 'sm' }) => {
  if (status === null || status === undefined) return null;

  const isPaid = status === 'PAID';
  const bg = isPaid ? PAID_BG : UNPAID_BG;
  const color = isPaid ? PAID_COLOR : UNPAID_COLOR;
  const label = isPaid ? "To'langan" : "To'lanmagan";
  const Icon = isPaid ? CheckCircleFilled : ClockCircleOutlined;

  const fontSize = size === 'md' ? 12 : 11;
  const padding = size === 'md' ? '4px 10px' : '3px 8px';
  const iconSize = size === 'md' ? 11 : 10;
  const gap = size === 'md' ? 5 : 4;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap,
        fontSize,
        fontWeight: 600,
        color,
        background: bg,
        borderRadius: 20,
        padding,
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
      }}
    >
      <Icon style={{ fontSize: iconSize }} />
      {label}
    </span>
  );
};
